"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_VerificationResult_Attestation = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Signature_1 = require("./RTTI_Signature");
exports.RTTI_VerificationResult_Attestation = t.recursion('IVerificationResult_Attestation', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        who: RTTI_Reference_1.RTTI_Reference,
        onBehalfOf: RTTI_Reference_1.RTTI_Reference,
        communicationMethod: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        date: RTTI_date_1.RTTI_date,
        _date: RTTI_Element_1.RTTI_Element,
        sourceIdentityCertificate: t.string,
        _sourceIdentityCertificate: RTTI_Element_1.RTTI_Element,
        proxyIdentityCertificate: t.string,
        _proxyIdentityCertificate: RTTI_Element_1.RTTI_Element,
        proxySignature: RTTI_Signature_1.RTTI_Signature,
        sourceSignature: RTTI_Signature_1.RTTI_Signature
    });
});
//# sourceMappingURL=RTTI_VerificationResult_Attestation.js.map